import { lt } from './localized'
import type { OnboardingStep } from './types'

export const INTRO_LINES = [
  lt('Het is twee jaar geleden.', 'It has been two years.'),
  lt(
    'Van de buurt ben ik alleen nog over. De rest is weg of stil.',
    "I'm what's left of our group. The rest is gone or didn't return.",
  ),
  lt('Elke dag is een rekensom van honger, dorst en lef.', 'Each day is a battle against hunger, thirst, and nerves.'),
  lt('Stuur iemand op pad. Kom terug met iets dat telt.', 'I need to find more survivors.'),
]

/** Tutorial expedition phases moved to the quest log (`starter_survival`). */
export const ONBOARDING_ACTIVE_STEPS: OnboardingStep[] = [
  'character_create',
  'intro',
]

export function isOnboardingActive(step: OnboardingStep): boolean {
  return ONBOARDING_ACTIVE_STEPS.includes(step)
}

export function nextOnboardingStep(step: OnboardingStep): OnboardingStep {
  switch (step) {
    case 'not_started':
      return 'character_create'
    case 'character_create':
      return 'intro'
    case 'intro':
      return 'done'
    case 'survivor_intro_1':
    case 'survivor_intro_2':
    case 'survivor_intro_3':
      return 'done'
    case 'first_expedition':
      return 'done'
    case 'first_return':
      return 'done'
    case 'workstation_hint':
      return 'done'
    case 'done':
      return 'done'
  }
}

export function forceStartOnboarding(): OnboardingStep {
  return 'character_create'
}
